import isToday from "date-fns/is_today";
import isYesterday from "date-fns/is_yesterday";
import format from "date-fns/format";
import { formatDate } from "./date-utils/DateUtils";

/**
 * Takes a dialogue array and groups by date
 *
 * @param {array} dialogues
 * @param {object} profile
 * @param {array} countryList
 * @param {object} locale
 */
export const groupDialoguesByDate = (dialogues, profile, countryList, locale) => {
  const dialoguesByGroup = {};
  dialogues.map(dialogue => {
    const createdDate = new Date(dialogue.created);
    let date = formatDate(createdDate, profile, countryList, locale);
    date = isToday(createdDate) ? "Today" : date;
    date = isYesterday(createdDate) ? "Yesterday" : date;
    const existingData = dialoguesByGroup[date];
    if (existingData) {
      dialoguesByGroup[date] = [...dialoguesByGroup[date], dialogue];
    } else {
      dialoguesByGroup[date] = [dialogue];
    }
  });
  const dialoguesByGroupsKeys = Object.keys(dialoguesByGroup);
  const sectionListData = [];
  dialoguesByGroupsKeys.map(date => {
    sectionListData.push({
      title: date,
      data: dialoguesByGroup[date]
    });
  });
  return sectionListData;
};
export const getMessageCreatedFormatedDate = (created, profile, countryList, locale) => {
  let date = formatDate(created, profile, countryList, locale);
  date = isToday(created) ? "Today" : date;
  date = isYesterday(created) ? "Yesterday" : date;
  return `${date}`;
};